import packageInfo from '../../package.json';

export const environment = {
  appVersion: packageInfo.version,
  releaseDate: '20 Jan 2026',
  author: {
    name: packageInfo.author,
    url: 'https://homeplus.services',
  },
  contact: 'support@homeplus.services',
  website: 'https://homeplus.services',
  terms: 'https://homeplus.services/terms.html',
  production: false,
  communityId: 1,
  applicationName: 'HomePlus Services',
};
